import { render } from "./desactivate.vue?vue&type=template&id=79e49943&scoped=true"
import script from "./desactivate.vue?vue&type=script&lang=js"
export * from "./desactivate.vue?vue&type=script&lang=js"

import "./desactivate.vue?vue&type=style&index=0&id=79e49943&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e49943"]])

export default __exports__